var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.clients,"hide-default-footer":"","fixed-header":"","items-per-page":_vm.clients.length,"item-class":_vm.getRowClass},scopedSlots:_vm._u([{key:"item.accessLevel",fn:function(ref){
var item = ref.item;
return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.getSubAccesslevels(item))}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }